import { render, staticRenderFns } from "./ExtraServiceExpandImageThreshold.vue?vue&type=template&id=794afeb7"
import script from "@/scripts/modal/extraService/extraServiceExpandImageThreshold.js?vue&type=script&lang=js&external"
export * from "@/scripts/modal/extraService/extraServiceExpandImageThreshold.js?vue&type=script&lang=js&external"
import style0 from "./ExtraServiceExpandImageThreshold.vue?vue&type=style&index=0&id=794afeb7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports